import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Reader from "@/pages/Reader";
import { CountdownGate } from "@/components/CountdownGate";

function App() {
  return (
    <div className="App">
      <CountdownGate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/read" element={<Reader />} />
          </Routes>
        </BrowserRouter>
      </CountdownGate>
    </div>
  );
}

export default App;
